export enum DeliveryOptionsEnum {
  jnt = "J&T",
  techOut = "Tech Out",
  techOutFree = "Tech Out - Free",
  pickup = "Pickup",
}
